// Keep local inputs immediate. Only the persistence job waits for a typing pause.
// Continuous typing still checkpoints after maxWait; discrete actions/blur flush.
export function createDeferredAnswerSaves(delay = 350, maxWait = 1500) {
  type Entry = {
    job: () => void
    quiet: ReturnType<typeof setTimeout>
    limit: ReturnType<typeof setTimeout>
  }
  const jobs = new Map<string, Entry>()
  const cancel = (key?: string) => {
    for (const [id, entry] of jobs)
      if (key === undefined || key === id) {
        clearTimeout(entry.quiet)
        clearTimeout(entry.limit)
        jobs.delete(id)
      }
  }
  const flush = (key?: string) => {
    for (const [id, entry] of Array.from(jobs))
      if (key === undefined || key === id) {
        cancel(id)
        entry.job()
      }
  }
  const queue = (key: string, job: () => void) => {
    const previous = jobs.get(key)
    if (previous) {
      clearTimeout(previous.quiet)
      previous.job = job
      previous.quiet = setTimeout(() => flush(key), delay)
    } else {
      jobs.set(key, {
        job,
        quiet: setTimeout(() => flush(key), delay),
        limit: setTimeout(() => flush(key), maxWait),
      })
    }
  }
  return { queue, flush, cancel }
}
